'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEntityFromResponse = exports.getEntityFromResponse = function getEntityFromResponse(action, key) {
  var composerSettings = Object.keys(action.response.entities.composer_settings).map(function (k) {
    return action.response.entities.composer_settings[k];
  })[0];
  return composerSettings.site && composerSettings.site[key];
};
var getPublishedDraftFromResponse = exports.getPublishedDraftFromResponse = function getPublishedDraftFromResponse(action) {
  var composerSettings = Object.keys(action.response.entities.composer_settings).map(function (k) {
    return action.response.entities.composer_settings[k];
  })[0];
  var publishedDraft = true;
  if (typeof composerSettings.publishedDraft != 'undefined') publishedDraft = composerSettings.publishedDraft;
  return publishedDraft;
};
var getEventUri = exports.getEventUri = function getEventUri(state) {
  return Object.keys(state.site.entities.events).map(function (k) {
    return state.site.entities.events[k];
  })[0].eventUri;
};

// Currently this method get the first business conference in the event
var getBusinessConference = exports.getBusinessConference = function getBusinessConference(state) {
  if (!state || !state.site.entities.business_conferences) return null;
  return Object.keys(state.site.entities.business_conferences)[0];
};